import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader
// Translation provided by Vuetify (typescript)
import en from 'vuetify/src/locale/en';
import fr from 'vuetify/src/locale/fr';
import { getTheme } from '@/themes';

Vue.use(Vuetify);

const theme = getTheme();

export default new Vuetify({
  icons: {
    iconfont: 'mdi' // default - only for display purposes
  },
  theme: {
    options: { customProperties: true }, // Enables --v-primary-base CSS variable
    themes: {
      light: { primary: theme.primary },
      dark: { primary: theme.primary }
    }
  },
  lang: {
    locales: { en, fr },
    current: 'fr'
  }
});
